import { createContext, useContext, useState } from 'react';

const BorderContext = createContext();

export const useBorder = () => useContext(BorderContext);

export const BorderProvider = ({ children }) => {
  const [showBorders, setShowBorders] = useState(false);
  const [cellsForDelete, setCellsForDelete] = useState();

  return (
    <BorderContext.Provider
      value={{
        showBorders,
        setShowBorders,
        cellsForDelete,
        setCellsForDelete,
      }}
    >
      {children}
    </BorderContext.Provider>
  );
};
